"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  var _super = _createSuper(Tab);

  function Tab(props) {
    var _this;

    _classCallCheck(this, Tab);

    _this = _super.call(this, props);
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          activeTab = _this$props.activeTab,
          value = _this$props.value,
          children = _this$props.children;

      if (_lodash["default"].isEqual(activeTab, value)) {
        this.setContent(children);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var activeTab = nextProps.activeTab,
          value = nextProps.value,
          children = nextProps.children;

      if (!_lodash["default"].isEqual(activeTab, this.props.activeTab) && _lodash["default"].isEqual(activeTab, value)) {
        this.setContent(children);
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      event.preventDefault();

      if (event.charCode === 13 || event.charCode === 32) {
        this.props.onChange(this.props.value);
      }
    }
  }, {
    key: "setContent",
    value: function setContent(children) {
      var childrenElement = _lodash["default"].isEmpty(children) ? null : children;
      this.props.setContent(childrenElement);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          className = _this$props2.className,
          style = _this$props2.style,
          activeTab = _this$props2.activeTab,
          value = _this$props2.value,
          label = _this$props2.label;

      var tabClass = function tabClass() {
        return (0, _classnames["default"])({
          'ui-tab': true,
          'ui-tab--active': activeTab === value
        }, className);
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-tab-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: id,
        className: tabClass(),
        style: style,
        onClick: function onClick() {
          return _this2.props.onChange(value);
        },
        role: "button",
        tabIndex: 0,
        onKeyPress: this.onKeyPress
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-tab__label"
      }, label)));
    }
  }]);

  return Tab;
}(_react.Component);

Tab.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,

  /** className for reference */
  className: _propTypes["default"].string,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,

  /** Sets the text value of the tab item to the string specified. */
  label: _propTypes["default"].string.isRequired,

  /** If value prop passed to Tabs component, this value prop is also required. It assigns a value to the tab so that it can be selected by the Tabs. */
  value: _propTypes["default"].string.isRequired,

  /**
   * Called when the selected value change.
   * @ignore
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * active tab value
   * @ignore
   */
  activeTab: _propTypes["default"].string,

  /**
   * set Content on active Tab
   * @ignore
   */
  setContent: _propTypes["default"].func,

  /**
   * children props for content inside
   * @ignore
   */
  children: _propTypes["default"].node
};
Tab.defaultProps = {
  id: '',
  className: '',
  style: {},
  children: [],
  onChange: _lodash["default"].noop,
  label: '',
  setContent: _lodash["default"].noop,
  activeTab: ''
};
var _default = Tab;
exports["default"] = _default;